import { DateInputDE } from './DateInputDE';

/**
 * Datumsbereichs-Filterpaar „von/bis" (F9, Optimierung 2026-08-25): stand
 * byte-gleich in Aktivität, Auswertungen und Offenen Posten (plus zwei
 * Varianten ohne Breite in der Arbeitszeit) — jetzt EIN Bauteil mit
 * einheitlicher Feldbreite.
 */
export function DateRangeFilter({
  from,
  to,
  setFrom,
  setTo,
  w = 160,
}: {
  from: string;
  to: string;
  setFrom: (v: string) => void;
  setTo: (v: string) => void;
  w?: number;
}) {
  return (
    <>
      <DateInputDE placeholder="von TT.MM.JJJJ" value={from} onChange={setFrom} w={w} />
      <DateInputDE placeholder="bis TT.MM.JJJJ" value={to} onChange={setTo} w={w} />
    </>
  );
}
